import React, { useState } from 'react';
import { Tooltip, Button } from 'antd';
import BaseField from '../BaseField';
import styles from './index.module.scss';

const EditForm = ({ value: inputValue, onCancel, onOk, fieldProps }) => {
  const [value, setValue] = useState(inputValue);

  const normalizedVal = value?.trim();
  const showOkBtn = Boolean(normalizedVal && inputValue !== normalizedVal);

  const handleCancel = () => {
    setValue(inputValue);
    onCancel();
  };

  return (
    <div className={styles.root}>
      <BaseField
        value={value}
        onChange={setValue}
        fieldProps={fieldProps}
        hasAddonAfter
      />
      <div className={styles.btns}>
        <Tooltip title="Отменить">
          <Button
            shape="circle"
            className={styles.btn}
            icon="close"
            onClick={handleCancel}
          />
        </Tooltip>
        {showOkBtn && (
          <Tooltip title="Сохранить">
            <Button
              shape="circle"
              className={styles.btn}
              icon="check"
              onClick={() => onOk(value)}
            />
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default EditForm;
